var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTopGamesJune = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 12H8v2h4v-2h-1v-1.977l7-6.84L14.78 0H5.22L2 3.183l7 6.84V12zM6.042 2h7.916l1.189 1.175L10 8.204l-5.147-5.03L6.042 2zM10 15h4v2H6v-2h4zm-7 3h14v2H3v-2z",
  fill: "#FDA700"
})));
export { SvgTopGamesJune as ReactComponent };
export default __webpack_public_path__ + "assets/icons/top_games_june.3bd9a1.svg";